// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__rZ4vv","Label":"BuildControl_Label__3qawe","Less":"BuildControl_Less__3Vxwl","More":"BuildControl_More__1k6oC"};